/**
 * payment/fetch-cancel-withdraw.js
 */
import actions from '../../common/lib/utils/actions.js';
import constants from '../../common/lib/utils/constants.js';
import core from '../../common/lib/core.js';
import dataflow from '../../common/lib/dataflow.js';

import view from './view.js';
// const view = {
// 	update() {}
// };

const state = {
	success: null,
	locked: null,
	withdrawId: null
};
const register = dataflow.register;

let requestUrl;

function viewUpdate() {
	view.update({
		fetch_cancel_withdraw: state
	});
}

function parseToState(data) {
	const dataStatusFailure = Boolean(data && data.status) && (data.status.toLowerCase && data.status.toLowerCase() === 'failure');
	const dataStatusSuccess = Boolean(data && data.status) && (data.status.toLowerCase && data.status.toLowerCase() === 'success');
	state.failure = dataStatusFailure;
	state.success = dataStatusSuccess;
	/* dev: temp setting failure to test succesful ajax response with status.FAILURE */
	// state.failure = true;
	// state.success = !state.failure;
	/* dev: end */
	viewUpdate();
	if (state.success) {
		actions.fetchCancelWithdraw(state);
	}
}

function getDataAndReplaceState(id) {
	/* non-dev*/
	const url = requestUrl + id;
	/* non-dev:end */
	/* dev: temp setting to simulate connection error. Comment away the previous line: url = requestUrl + id */
	// const url = (`${requestUrl + id}tempFailProvoce`);
	/* dev: end */
	state.failure = false; /* this is the flag for a successful response with a status of failure */
	state.success = false; /* this is the flag for a successful response with a status of success */
	state.error = null; /* this is the message for connection errors (example http-responses 404) */
	parseToState(null);
	core.get(url, (data) => {
		parseToState(data);
	}, (err) => {
		state.error = err; /* this is a failure with connection error */
		viewUpdate();
		console.error('fetch_cancel_withdraw:getDataAndReplaceState:55:error:', err);
	});
}

function registerActions() {
	function fetchCancelWithdraw(payload) {
		const definedData = Boolean(payload.data && typeof payload.data !== 'undefined' && payload.data !== 'undefined');
		/* sometimes 'undefined' is returned which evaluates to true beacuse it is a string and not the global */
		if (payload.type === constants.VIEW_PENDING_WITHDRAWALS) {
			if (definedData) {
				state.withdrawId = (payload.data || -1);
				getDataAndReplaceState(state.withdrawId);
			} else {
				console.error('fetch_cancel_withdraw:error no withdraw-id');
			}
		}
	}
	register(fetchCancelWithdraw);
}

export default {
	init(url) {
		if (url) {
			requestUrl = url;
		} else {
			console.error('fetch_pending_withdrawals:59:init: no url provided', url);
		}
		registerActions();
	}
};



// WEBPACK FOOTER //
// ./mobile-core/src/payment/pendingwithdrawals/lib/fetch-cancel-withdraw.js